import { useTranslation } from 'react-i18next';
import BoldBlue from './BoldBlue';
import Popup from './Popup';
import { useState } from 'react';
import Input from './Input';

const PressLinksAdd = (props) => {

    const { i18n } = useTranslation('common');
    const [popupOpen, setPopupOpen] = useState(false); 
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');

    let decodedLinks = [];
    try {
        decodedLinks = JSON.parse(props.pressLinks);
    } catch (error) {
        console.log(error);
    }

    function addLink(event) {
        event.preventDefault();
        let newLink = {
            title,
            url
        }
        decodedLinks.push(newLink);
        props.setPressLinks(JSON.stringify(decodedLinks));
        setPopupOpen(false);
        setTitle('');
        setUrl('');
    }

    return (
        <>
            <BoldBlue style={{cursor:"pointer"}} onClick={() => setPopupOpen(true)}>{i18n.language === "fr" ? "Ajouter un lien presse" : "Add a press link"} +</BoldBlue><br/>
            {popupOpen &&
                <Popup close={() => setPopupOpen(false)}>
                    <span className='thin'>{i18n.language === "fr" ? "Ajouter un lien presse" : "Add a press link"}</span><br/>
                    <Input style={{width:"100%"}} onChange={(event) => setTitle(event.target.value)} placeholder={i18n.language === "fr" ? "Texte du lien" : "Link text"} /><br/>
                    <Input style={{width:"100%"}} onChange={(event) => setUrl(event.target.value)} placeholder={i18n.language === "fr" ? "URL du lien" : "Link URL"} /><br/>
                    {title && url && <button onClick={addLink}>{i18n.language === 'fr' ? 'Ajouter' : 'Add'}</button>}
                </Popup>
            }
        </>
    );
};

export default PressLinksAdd;
